import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Outer } from './Outer';
import { Home } from '../Home';

export const Router: React.FC = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<Outer />}>
					<Route path="/*" element={<Home />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
};
